import { useEventListener } from '../../../hooks/useEventListener';
import React, { useState } from 'react';

type Props = {
    errorMessage?: string;
    onClick: () => void;
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    code?: string;
    error?: boolean;
    text?: string;
};

export default function GameSelectCardCodeInput({ errorMessage, onClick, onChange, code, error, text }: Props) {
    const [dragging, setDragging] = useState(false);

    const handleClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        e.preventDefault();
        if (!dragging) {
            onClick && onClick();
        }
        setDragging(false);
    };

    const handleTouch = (e: React.TouchEvent<HTMLDivElement>) => {
        e.preventDefault();
        if (!dragging) {
            onClick && onClick();
        }
        setDragging(false);
    };

    function submitHandler(e: React.FormEvent<HTMLInputElement>) {
        e.preventDefault();
    }

    function enterHandler({ key }: KeyboardEvent) {
        if ('Enter' === String(key)) {
            onClick();
        }
    }

    useEventListener('submit', submitHandler);
    useEventListener('keydown', enterHandler);

    return (
        <React.Fragment>
            <div className="game-select-card__code-input">
                <div className="game-select-card__code-input__container">
                    {error && <div className="game-select-card__code-input__error">{errorMessage}</div>}
                    <form className="game-select-card__code-input__form" action="">
                        <input
                            className="game-select-card__code-input__form-input"
                            placeholder={text ? text : 'Zadejte jméno týmu'}
                            type="text"
                            value={code}
                            onChange={onChange}
                            maxLength={21}
                        />
                        <label className="game-select-card__code-input__label" htmlFor="checkbox">
                            <div
                                className="game-select-card__code-input__button"
                                onTouchStart={() => {
                                    setDragging(false);
                                }}
                                onTouchMove={() => {
                                    setDragging(true);
                                }}
                                onTouchEnd={handleTouch}
                                onClick={handleClick}
                            >
                                OK
                            </div>
                        </label>
                    </form>
                </div>
            </div>
        </React.Fragment>
    );
}
